module.exports = __webpack_public_path__ + "img/propuesta.f8a9ed54.svg";